import { RegistryLayoutStoreProvider } from "../stores/useRegistryLayoutStore";
import RegistryDataGrid from "./RegistryDataGrid";

interface IProps {
  registryId: string;
}

const RegistryContainer = ({ registryId }: IProps) => {
  return (
    <RegistryLayoutStoreProvider>
      <RegistryDataGrid registryId={registryId}></RegistryDataGrid>
    </RegistryLayoutStoreProvider>
  );
};

export default RegistryContainer;
